import script from "./recoverycoitnCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./recoverycoitnCopy.vue?vue&type=script&setup=true&lang=js"

import "./recoverycoitnCopy.vue?vue&type=style&index=0&id=4ea7bfc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea7bfc0"]])

export default __exports__